/* eslint-disable no-unused-vars */
import React, { Component, Suspense, lazy} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../src/components/common/Loader";
import logo from './logo.svg';
import './App.css';
import { AgencyProvider } from './components/contexts/AgencyContext';

const Authenticated = lazy(() => import('../src/components/pages/AuthRouting'));

class App extends Component{
    constructor(props){
        super(props);
        this.state = {};
    };

    renderSpinner(){ return <Loader />; };

    render(){
        return (
            <div>
                <AgencyProvider>
                    <Suspense fallback={this.renderSpinner()}>
                        <Authenticated />
                    </Suspense>
                    <ToastContainer />
                </AgencyProvider>
            </div>
        );
    };
};
export default App;